'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StateEmpty = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styles = require('@material-ui/styles');

var _Typography = require('../Typography');

var _Button = require('../Button');

var _state = require('../../schema/component/state.json');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable import/no-extraneous-dependencies */


var empty = _state.properties.empty.properties;

var useStyles = (0, _styles.makeStyles)(function () {
  return {
    container: {
      margin: '0 auto',
      maxWidth: function maxWidth(_ref) {
        var containerWidth = _ref.containerWidth;
        return containerWidth;
      },
      textAlign: 'center',
      '& button': {
        minWidth: '228px',
        '& div': {
          textAlign: 'center'
        }
      }
    },
    image: {
      height: function height(_ref2) {
        var imageHeight = _ref2.imageHeight;
        return imageHeight;
      },
      width: function width(_ref3) {
        var imageWidth = _ref3.imageWidth;
        return imageWidth;
      }
    }
  };
});

var StateEmpty = function StateEmpty(_ref4) {
  var action = _ref4.action,
      actionCustom = _ref4.actionCustom,
      className = _ref4.className,
      id = _ref4.id,
      image = _ref4.image,
      message = _ref4.message,
      size = _ref4.size,
      sizes = _ref4.sizes,
      title = _ref4.title,
      props = _objectWithoutProperties(_ref4, ['action', 'actionCustom', 'className', 'id', 'image', 'message', 'size', 'sizes', 'title']);

  var classes = useStyles({
    containerWidth: sizes && sizes.container || empty[size].properties.container,
    imageHeight: sizes && sizes.image && sizes.image.height || empty[size].properties.imageHeight,
    imageWidth: sizes && sizes.image && sizes.image.width || empty[size].properties.imageWidth
  });

  return _react2.default.createElement(
    'div',
    _extends({}, props, {
      className: classes.container + ' ' + className + ' state-empty',
      id: id
    }),
    _react2.default.createElement('img', {
      alt: 'Empty State',
      className: classes.image + ' state-empty--image',
      src: image,
      height: sizes && sizes.image && sizes.image.height || empty[size].properties.imageHeight,
      width: sizes && sizes.image && sizes.image.width || empty[size].properties.imageWidth,
      'data-margin-bottom': '24px'
    }),
    _react2.default.createElement(
      _Typography.Typography,
      {
        className: 'state-empty--title',
        variant: 'subtitle1-medium',
        'data-margin-bottom': '8px',
        'data-text-align': 'center'
      },
      title
    ),
    _react2.default.createElement(
      _Typography.Typography,
      {
        className: 'state-empty--message',
        variant: 'textbody2-reguler',
        'data-margin-bottom': '24px',
        'data-text-align': 'center'
      },
      message
    ),
    actionCustom,
    action && _react2.default.createElement(
      _Button.Button,
      { className: 'state-empty--action', onClick: action.event },
      action.title
    )
  );
};

exports.StateEmpty = StateEmpty;
StateEmpty.defaultProps = {
  action: empty.props.properties.action,
  actionCustom: empty.props.properties.actionCustom,
  className: empty.props.properties.className,
  id: empty.props.properties.id,
  image: empty.props.properties.image,
  message: empty.props.properties.message,
  size: empty.props.properties.size,
  sizes: empty.props.properties.sizes,
  title: empty.props.properties.title
};

StateEmpty.propTypes = {
  action: _propTypes2.default.shape({
    event: _propTypes2.default.func,
    title: _propTypes2.default.string
  }),
  actionCustom: _propTypes2.default.node,
  className: _propTypes2.default.string,
  id: _propTypes2.default.string,
  image: _propTypes2.default.string,
  message: _propTypes2.default.string,
  size: _propTypes2.default.string,
  sizes: _propTypes2.default.shape({
    container: _propTypes2.default.string,
    image: _propTypes2.default.shape({
      height: _propTypes2.default.string,
      width: _propTypes2.default.string
    })
  }),
  title: _propTypes2.default.string
};

exports.default = StateEmpty;